import Slider from './modules/slider';
import Calendar from './modules/calendar';
import Pagination from './modules/pagination';
import CountDown from './modules/countdown-timer';
export { Slider, Calendar, Pagination, CountDown, };
//# sourceMappingURL=index.js.map